import { render, staticRenderFns } from "./MailOut.vue?vue&type=template&id=5bb98b46&"
import script from "./MailOut.vue?vue&type=script&lang=js&"
export * from "./MailOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports